module.exports = __webpack_public_path__ + "media/images/employees/dani-629d623f3ae9a980fd9e2d4423558963.png";